import {ProgressIndicator} from '@/components-v2/molecules/ProgressIndicator/ProgressIndicator'
import {Button} from '@/components-v2/atoms/Button/Button'
import {HeaderTitle} from '@/components/atoms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {ProductComboFooter} from '@/features/ProductCombo/ProductComboFooter'
import {ProductComboStep, ProductComboSteps} from '@/features/ProductCombo/ProductComboStep'
import {Header} from '@/utils/constants/header'
import {ROUTES} from '@/utils/constants/routesConstants'
import {productCombinationProgressLevelSteps} from '@/utils/productCombo/productComboConstants'
import {useMatch, useNavigate} from 'react-router-dom'
import {PublishedComboHeader} from './ComboDetail/PublishedComboHeader'

export const CreateProductCombo = () => {
  const {
    currentStep,
    setCurrentStep,
    productCombo: {isDraft},
  } = useProductCombo()
  const navigate = useNavigate()
  const isComboDetailPage = Boolean(useMatch(ROUTES.PRODUCT_COMBO_DETAIL))

  const isDetailsView = currentStep === ProductComboSteps.REVIEW && isComboDetailPage

  const handleBack = () => {
    if (isDetailsView || currentStep === ProductComboSteps.SETUP) {
      navigate(ROUTES.PRODUCTS_LIST)
      return
    }

    setCurrentStep(previousStep => previousStep - 1)
  }

  return (
    <div className="product-combo flex flex-col gap-4">
      <Button text="Back" variant="tertiary" iconLeading="arrow_back_ios" onClick={handleBack} />
      {isDetailsView ? (
        <PublishedComboHeader />
      ) : (
        <>
          <HeaderTitle
            title={isDraft === false ? 'Edit Combo' : 'Create Combo'}
            headingLevel={Header.PageHeader}
            className="$font-heading-h3-bold"
          />
          <ProgressIndicator
            currentStep={currentStep}
            steps={4}
            titles={productCombinationProgressLevelSteps}
            className="p-6"
          />
        </>
      )}

      <ProductComboStep step={currentStep} />

      {!isDetailsView && <ProductComboFooter />}
    </div>
  )
}
